import {
  AllessehQueryRules,
  AllessehQuerySortKeyTypes,
  AllessehQuerySortOrderType
} from 'hooks/useAllessehContentQuery';

export const DEFAULT_PRODUCT_VALUE = 'WSJ.com';

export const COMMON_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [{ term: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }],
  not: [
    {
      terms: {
        key: 'SectionType',
        value: ['infogrfx slide show']
      }
    },
    {
      terms: {
        key: 'SectionType',
        value: ['style & substance']
      }
    },
    {
      terms: {
        key: 'SectionType',
        value: ['corrections']
      }
    }
  ]
};

export const COMMON_RELATED_OPINION_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [
    { term: { value: 'opinion', key: 'PrimaryDJEThing' } },
    { term: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }
  ]
};

export const DEFAULT_SORT_CONFIG = {
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }]
};
